'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'chess-rook';
var width = 384;
var height = 512;
var aliases = [9820];
var unicode = 'f447';
var svgPathData = 'M384 192l-48 64 0 128 48 80 0 48-384 0 0-48 48-80 0-128-48-64 0-192 384 0 0 192zM75.4 400.5l-43.4 72.4 0 7.2 320 0 0-7.2-43.4-72.4-.3-.5-232.6 0-.3 .5zM32 181.3l41.6 55.5 6.4 8.5 0 122.7 224 0 0-122.7 6.4-8.5 41.6-55.5 0-149.3-80 0 0 64-32 0 0-64-96 0 0 64-32 0 0-64-80 0 0 149.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChessRook = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;